// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#pwt-custom-active-tab[data-v-2af1eec2]{border-radius:10px 10px 0 0;background-color:#2eaeff}.pwt-custom-active-tab-text[data-v-2af1eec2]{z-index:1101}.pwt-tabs-border[data-v-2af1eec2]{border-bottom:2px solid var(--v-primary-base)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
